import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Dropdown } from "react-bootstrap";
import bootsIcon from "../../assets/images/boots_logo.png";
import { useAuth } from "../AuthContext/AuthContext";
import { useNavigate, Link } from "react-router";
import useApis from "../../services/useAPI";
import { logoutUrl, ssoLogoutUrl } from "../../utils/constants";
import { BoxArrowInRight } from "react-bootstrap-icons";

// import {toggleTrainingStart, toggleTrainingStop} from "../../stories/LoggedInScreens/Sidebar.jsx"
import useTraining from "../../services/useTraining";
import { isTrainingUser } from "../../utils/utils";
const Header = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const {
    toggleTrainingStart,
    toggleTrainingStop,
  } = useTraining();

  const { callApi } = useApis(logoutUrl, "POST");
  const selectedStore = JSON.parse(sessionStorage.getItem("selectedStore") || "null");

  const handleLogout = async () => {
    try {
      await callApi();
    } catch (e) {
      // Handle error if needed
    }
    auth.logout();
    window.location.assign(ssoLogoutUrl);
    navigate("/login");
    auth?.showToast(
      "Logged out",
      "Logged out successfully!",
      "../assets/mhc.png",
      {icon: <BoxArrowInRight />,
      className: auth?.featureFlag && "vh-toaster",},
    );
  };

  const formatUserName = (fullName = "") => {
    const parts = fullName.trim().split(" ");

    if (parts.length === 1) {
      return parts[0];
    }

    return `${parts[0]} ${parts[1][0]}.`;
  };

  return (
    <div className="header-ui">
      <Container>
        <Row>
          <Col className="col-12 position-relative d-flex flex-row justify-content-between header-content px-0">
            <div className="header-logo">
              <Link to="/patient-record" replace>
                <img src={bootsIcon} alt="Boots Logo" />
              </Link>
            </div>

            {auth.isAuthenticated && (
              <div className="d-flex flex-row gap-2 align-items-center">
                {selectedStore && (
                  <div className="selected-store">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C16.4183 2 20 5.58172 20 10C20 16 12 22 12 22C12 22 4 17 4 10C4 5.58172 7.58172 2 12 2ZM12 4C8.68629 4 6 6.68629 6 10C6 12.7424 7.58698 15.2679 9.45605 17.2539C10.3404 18.1935 11.2309 18.9509 11.9131 19.4805C11.9195 19.4749 11.9262 19.4695 11.9326 19.4639C12.6385 18.8462 13.5749 17.9672 14.5049 16.9209C16.4587 14.7228 18 12.2099 18 10C18 6.68629 15.3137 4 12 4ZM12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z" fill="white"/>
                    </svg>
                    <span>{selectedStore.store_number}</span>
                  </div>
                )}              
                <Dropdown align="end" className="header-profile-dropdown">
                  <Dropdown.Toggle
                    id="profile-dropdown"
                    className="profile-toggle"
                  >
                    <div className="profile-avatar"></div>
                    <div className="d-flex gap-2 align-items-center">
                      <span>{auth.userInitials && formatUserName(auth.userInitials)}</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3 5.76297L3.72844 5L8 9.47405L12.2716 5L13 5.76297L8 11L3 5.76297Z"
                          fill="#F6F6F9"
                        />
                      </svg>
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="profile-menu">
                    <Dropdown.Item as={Link} to="/account">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 13C16.841 13 21 16.4605 21 21H19C19 17.8075 15.9956 15 12 15C8.0044 15 5 17.8075 5 21H3C3 16.4605 7.15904 13 12 13ZM12 3C14.4853 3 16.5 5.01472 16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3ZM12 5C10.6193 5 9.5 6.11929 9.5 7.5C9.5 8.88071 10.6193 10 12 10C13.3807 10 14.5 8.88071 14.5 7.5C14.5 6.11929 13.3807 5 12 5Z"
                          fill="#33333F"
                        />
                      </svg>
                      <span>My account</span>
                    </Dropdown.Item>

                    <Dropdown.Item as={Link} to="/change-password">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2C14.7614 2 17 4.23858 17 7V10H19V18C19 20.2091 17.2091 22 15 22H9C6.79086 22 5 20.2091 5 18V10H7V7C7 4.23858 9.23858 2 12 2ZM7 18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V12H7V18ZM12 4C10.3431 4 9 5.34315 9 7V10H15V7C15 5.34315 13.6569 4 12 4Z"
                          fill="#33333F"
                        />
                      </svg>
                      <span>Change password</span>
                    </Dropdown.Item>
                    {isTrainingUser() && (
                        <>
                          <Dropdown.Item onClick={toggleTrainingStart}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 2C14.7614 2 17 4.23858 17 7V10H19V18C19 20.2091 17.2091 22 15 22H9C6.79086 22 5 20.2091 5 18V10H7V7C7 4.23858 9.23858 2 12 2ZM7 18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V12H7V18ZM12 4C10.3431 4 9 5.34315 9 7V10H15V7C15 5.34315 13.6569 4 12 4Z"
                                fill="#33333F"
                              />
                            </svg>
                            <span>Start Training</span>
                          </Dropdown.Item>

                          <Dropdown.Item onClick={toggleTrainingStop}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 2C14.7614 2 17 4.23858 17 7V10H19V18C19 20.2091 17.2091 22 15 22H9C6.79086 22 5 20.2091 5 18V10H7V7C7 4.23858 9.23858 2 12 2ZM7 18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V12H7V18ZM12 4C10.3431 4 9 5.34315 9 7V10H15V7C15 5.34315 13.6569 4 12 4Z"
                                fill="#33333F"
                              />
                            </svg>
                            <span>Reset Training</span>
                          </Dropdown.Item>
                        </>
                      )}

                    <Dropdown.Divider />

                    <Dropdown.Item onClick={handleLogout}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 4C11.6569 4 13 5.34315 13 7V8H11V7C11 6.44772 10.5523 6 10 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H10C10.5523 18 11 17.5523 11 17V16H13V17C13 18.6569 11.6569 20 10 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H10ZM20.9141 11H21V11.0859L21.9141 12L21 12.9141V13H20.9141L17.207 16.707L15.793 15.293L18.0859 13H8V11H18.0859L15.793 8.70703L17.207 7.29297L20.9141 11Z"
                          fill="#33333F"
                        />
                      </svg>
                      <span>Log out</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Header;
